import { Col, Row, Statistic, Typography, Divider } from 'antd';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { formatVND } from '@/utils/format';
import type { OrderSummary } from '@/mocks/orders';

const { Text } = Typography;

interface Props {
  totalOrders: number;
  summary?: OrderSummary;
}

export function OrderShiftSummary({ totalOrders, summary }: Props) {
  const totalAmount = summary?.total_amount ?? 0;
  const cash = summary?.payment_summary?.cash ?? 0;
  const transfer = summary?.payment_summary?.transfer ?? 0;
  const card = summary?.payment_summary?.card ?? 0;
  const mix = summary?.payment_summary?.mix ?? 0;
  const other = summary?.payment_summary?.other ?? 0;
  const cardWallet = card + mix + other;

  const chartData = summary?.revenue_by_hour ?? [];

  return (
    <div style={{ borderRadius: 8, border: '1px solid #f0f0f0', padding: '16px 20px' }}>
      <Typography.Title level={5} style={{ margin: '0 0 12px 0', display: 'flex', alignItems: 'center', gap: 6 }}>
        📊 Tổng kết ca hiện tại
      </Typography.Title>
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Statistic title="Tổng đơn" value={totalOrders} suffix="đơn" valueStyle={{ fontSize: 18, fontWeight: 600 }} />
        </Col>
        <Col span={16}>
          <Statistic title="Tổng doanh thu" value={formatVND(totalAmount)} valueStyle={{ fontSize: 18, fontWeight: 600, color: '#a4193d' }} />
        </Col>
      </Row>
      <Divider style={{ margin: '12px 0' }} />
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Statistic title="💵 Tiền mặt" value={formatVND(cash)} valueStyle={{ fontSize: 14, fontWeight: 500 }} />
        </Col>
        <Col span={8}>
          <Statistic title="💳 Chuyển khoản" value={formatVND(transfer)} valueStyle={{ fontSize: 14, fontWeight: 500 }} />
        </Col>
        <Col span={8}>
          <Statistic title="📱 Ví / Thẻ / Khác" value={formatVND(cardWallet)} valueStyle={{ fontSize: 14, fontWeight: 500 }} />
        </Col>
      </Row>
      <Divider style={{ margin: '16px 0' }} />
      <Typography.Title level={5} style={{ margin: '0 0 12px 0' }}>
        📈 Xu hướng doanh thu theo giờ
      </Typography.Title>
      <div style={{ width: '100%', height: 160 }}>
        {chartData.length > 0 && chartData.some(d => d.revenue > 0) ? (
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={chartData} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
              <defs>
                <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#a4193d" stopOpacity={0.3}/>
                  <stop offset="95%" stopColor="#a4193d" stopOpacity={0}/>
                </linearGradient>
              </defs>
              <XAxis dataKey="hour" tickLine={false} axisLine={false} style={{ fontSize: 10 }} />
              <YAxis tickLine={false} axisLine={false} style={{ fontSize: 10 }} tickFormatter={(v) => `${v / 1000000}M`} />
              <Tooltip formatter={(value: any) => [formatVND(Number(value)), 'Doanh thu']} />
              <Area type="monotone" dataKey="revenue" stroke="#a4193d" strokeWidth={2} fillOpacity={1} fill="url(#colorRevenue)" />
            </AreaChart>
          </ResponsiveContainer>
        ) : (
          <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafafa', borderRadius: 6 }}>
            <Text type="secondary" style={{ fontSize: 12 }}>Chưa có dữ liệu doanh thu trong ca</Text>
          </div>
        )}
      </div>
    </div>
  );
}
